/* Expiry also covers pricing fragments and their native sticky-bar clones. */
(() => {
  'use strict';
  if (window.__productValueMessageReady) return;
  window.__productValueMessageReady = true;

  function currentOffer(offer) {
    const starts = Number(offer.dataset.valueStarts);
    const expires = Number(offer.dataset.valueExpires);
    const now = Date.now() / 1000;
    return Number.isFinite(starts) && Number.isFinite(expires) && starts > 0 &&
      expires > starts && now >= starts && now < expires;
  }

  function hideExpired() {
    document.querySelectorAll('[data-value-offer]').forEach(offer => {
      if (!currentOffer(offer)) offer.hidden = true;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hideExpired, {once: true});
  } else {
    hideExpired();
  }
  document.addEventListener('shopify:section:load', hideExpired);
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) hideExpired();
  });
  window.addEventListener('pageshow', hideExpired);
  window.setInterval(hideExpired, 1000);
})();
